var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMrlIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9987 13.6663C3.3168 13.6663 0.332031 10.6815 0.332031 6.99967C0.332031 3.31777 3.3168 0.333008 6.9987 0.333008C10.6806 0.333008 13.6654 3.31777 13.6654 6.99967C13.6654 10.6815 10.6806 13.6663 6.9987 13.6663ZM5.47204 12.1113C4.83032 10.7503 4.43691 9.24914 4.35024 7.66634H1.70662C1.9707 9.78401 3.47629 11.5161 5.47204 12.1113ZM5.68583 7.66634C5.7861 9.29221 6.25056 10.8195 6.9987 12.1677C7.74683 10.8195 8.2113 9.29221 8.31156 7.66634H5.68583ZM12.2908 7.66634H9.64716C9.5605 9.24914 9.1671 10.7503 8.52536 12.1113C10.5211 11.5161 12.0267 9.78401 12.2908 7.66634ZM1.70662 6.33301H4.35024C4.43691 4.75019 4.83032 3.24905 5.47204 1.88805C3.47629 2.48323 1.9707 4.21534 1.70662 6.33301ZM5.68583 6.33301H8.31156C8.2113 4.70715 7.74683 3.17984 6.9987 1.83167C6.25056 3.17984 5.7861 4.70715 5.68583 6.33301ZM8.52536 1.88805C9.1671 3.24905 9.5605 4.75019 9.64716 6.33301H12.2908C12.0267 4.21534 10.5211 2.48323 8.52536 1.88805Z",
    fill: "#375393"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMrlIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MRLIcon.c475f4b4.svg";
export { ForwardRef as ReactComponent };